import { getStoredControlBackgroundSofteningLevel } from '@/common/control-background'
// 用户信息仓库
const userinfo = {
  state: {  ////用户的公共变量仓库  ///使用 this.$store.state.userinfo(子模组，没有时不写).userId（用户变量）
    userId:'',
    loginAccount: '', // 登录回填账号，与服务端内部 userId 分开。
    backgroundSofteningLevel: getStoredControlBackgroundSofteningLevel(),
  },
  mutations: {  ///同步提交信息的方法，组件中的使用 this.$store.commit('updataUserId（定义的方法名）' , '传入的参数')
    updataBackgroundSofteningLevel(state, value) { state.backgroundSofteningLevel = value; },
    updataLoginAccount(state, account) {
      state.loginAccount = account == null ? '' : String(account);
    },
    updataUserId(state,userId){
      state.userId = userId;
    }
  },
  actions: {
    asyUpdataLoginAccount(context, account) {
      context.commit('updataLoginAccount', account);
    },
    asyUpdataUserId(context,userId){
        context.commit('updataUserId',userId);
      }
  },
  modules: {
    
  }
}

export default userinfo